/**
 * @generated SignedSource<<f9a4dde0e082fa5e35703adb593a1078>>
 * @relayHash 38e158f41480cd21438d590d297af475
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 92f00bd8aeacd303c74abf1deafd512cf7949ed5a110618a10863ef16c0b4ee5

import type { ConcreteRequest } from 'relay-runtime';
export type ConvoAiSkillSource = "ANTHROPIC" | "STRATUS" | "%future added value";
export type composableEditorChat_GetAvailableSkillsQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  first?: number | null | undefined;
  shouldFetch?: boolean | null | undefined;
};
export type composableEditorChat_GetAvailableSkillsQuery$data = {
  readonly convoai_availableSkills?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "ConvoAiSkill";
        readonly category: string | null | undefined;
        readonly color: string | null | undefined;
        readonly description: string | null | undefined;
        readonly displayName: string | null | undefined;
        readonly iconKey: string | null | undefined;
        readonly iconUrl: string | null | undefined;
        readonly id: string;
        readonly integrationKeys: ReadonlyArray<string>;
        readonly integrations: ReadonlyArray<{
          readonly displayName: string | null | undefined;
          readonly iconUrl: string | null | undefined;
          readonly id: string | null | undefined;
          readonly key: string;
        }>;
        readonly name: string;
        readonly slashCommand: string | null | undefined;
        readonly source: ConvoAiSkillSource;
        readonly tags: ReadonlyArray<string>;
        readonly version: string | null | undefined;
      } | null | undefined;
    }> | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly metadata: {
      readonly anthropicCount: number;
      readonly isDegraded: boolean;
      readonly stratusCount: number;
    };
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null | undefined;
    };
    readonly totalCount: number;
  } | null | undefined;
};
export type composableEditorChat_GetAvailableSkillsQuery = {
  response: composableEditorChat_GetAvailableSkillsQuery$data;
  variables: composableEditorChat_GetAvailableSkillsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "shouldFetch"
},
v4 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v7 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v8 = [
  {
    "concreteType": "ConvoAiSkillEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "ConvoAiSkill",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          (v5/*: any*/),
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "description"
          },
          (v6/*: any*/),
          {
            "kind": "ScalarField",
            "name": "slashCommand"
          },
          (v7/*: any*/),
          {
            "kind": "ScalarField",
            "name": "iconKey"
          },
          {
            "kind": "ScalarField",
            "name": "color"
          },
          {
            "kind": "ScalarField",
            "name": "source"
          },
          {
            "kind": "ScalarField",
            "name": "tags"
          },
          {
            "kind": "ScalarField",
            "name": "category"
          },
          {
            "kind": "ScalarField",
            "name": "integrationKeys"
          },
          {
            "concreteType": "ConvoAiSkillIntegration",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              },
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "version"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "cursor"
      }
    ]
  },
  {
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "hasNextPage"
      },
      {
        "kind": "ScalarField",
        "name": "hasPreviousPage"
      },
      {
        "kind": "ScalarField",
        "name": "startCursor"
      },
      {
        "kind": "ScalarField",
        "name": "endCursor"
      }
    ]
  },
  {
    "kind": "ScalarField",
    "name": "totalCount"
  },
  {
    "concreteType": "ConvoAiSkillListMetadata",
    "kind": "LinkedField",
    "name": "metadata",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "anthropicCount"
      },
      {
        "kind": "ScalarField",
        "name": "stratusCount"
      },
      {
        "kind": "ScalarField",
        "name": "isDegraded"
      }
    ]
  },
  {
    "concreteType": "QueryError",
    "kind": "LinkedField",
    "name": "errors",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "message"
      }
    ]
  }
],
v9 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  (v4/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "composableEditorChat_GetAvailableSkillsQuery",
    "selections": [
      {
        "condition": "shouldFetch",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "convoai_availableSkills",
            "args": [
              (v4/*: any*/)
            ],
            "concreteType": "ConvoAiAvailableSkillsResult",
            "kind": "LinkedField",
            "name": "__Skills__convoai_availableSkills_connection",
            "plural": false,
            "selections": (v8/*: any*/)
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "composableEditorChat_GetAvailableSkillsQuery",
    "selections": [
      {
        "condition": "shouldFetch",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v9/*: any*/),
            "concreteType": "ConvoAiAvailableSkillsResult",
            "kind": "LinkedField",
            "name": "convoai_availableSkills",
            "plural": false,
            "selections": (v8/*: any*/)
          },
          {
            "args": (v9/*: any*/),
            "filters": [
              "cloudId"
            ],
            "handle": "connection",
            "key": "Skills__convoai_availableSkills",
            "kind": "LinkedHandle",
            "name": "convoai_availableSkills"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "92f00bd8aeacd303c74abf1deafd512cf7949ed5a110618a10863ef16c0b4ee5",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "convoai_availableSkills"
          ]
        }
      ]
    },
    "name": "composableEditorChat_GetAvailableSkillsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "cd43e143b802c128a6088ad9176a5cac";

export default node;
